import clsx from "clsx"
import { useContext } from "react"

import { BottomDrawerContext } from "@atoms/BottomDrawer/BottomDrawer"
import DrawerDragIndicator from "@atoms/BottomDrawer/DrawerDragIndicator/DrawerDragIndicator"

import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

import styles from "./DrawerHeader.module.scss"
import type {
    DrawerHeaderActionsProps,
    DrawerHeaderBackButtonProps,
    DrawerHeaderCloseButtonProps,
    DrawerHeaderRootProps,
    DrawerHeaderTitleProps,
} from "./DrawerHeader.types"

function DrawerHeaderRoot(props: DrawerHeaderRootProps) {
    const { hasDragIndicator } = useContext(BottomDrawerContext)
    const { className, showDivider = true, showDragHandle = hasDragIndicator, children } = props

    const hasBody = Boolean(children)

    if (showDragHandle || hasBody) {
        return (
            <div className={clsx(styles.base, className)}>
                {showDragHandle && <DrawerDragIndicator className={clsx({ [styles.dragHandleWithBody]: hasBody })} />}
                {hasBody && (
                    <PopoverHeader.Root className={styles.popoverHeader} showDivider={showDivider}>
                        {children}
                    </PopoverHeader.Root>
                )}
            </div>
        )
    } else {
        return null
    }
}

function DrawerHeaderTitle(props: DrawerHeaderTitleProps) {
    return <PopoverHeader.Title {...props} />
}

function DrawerHeaderActions(props: DrawerHeaderActionsProps) {
    return <PopoverHeader.Actions {...props} />
}

function DrawerHeaderBackButton(props: DrawerHeaderBackButtonProps) {
    return <PopoverHeader.BackButton {...props} />
}

function DrawerHeaderCloseButton(props: DrawerHeaderCloseButtonProps) {
    return <PopoverHeader.CloseButton {...props} />
}

export default {
    Root: DrawerHeaderRoot,
    Title: DrawerHeaderTitle,
    Actions: DrawerHeaderActions,
    BackButton: DrawerHeaderBackButton,
    CloseButton: DrawerHeaderCloseButton,
}
